
  import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
  import {
    Action,
    Getter,
  } from 'vuex-class';

  @Component({
    components: {},
  })
  export default class DlgSendCeoMail extends Vue {
    @Prop({type: Array, default: []}) private ceos!: any;
    @Prop({type: Object, default: null}) private training!: any;

    @Action('admin/trainings/readTemplates') private readTemplates!: (params: any) => Promise<any>;
    @Action('admin/trainings/sendMail') private sendMail!: any;

    @Getter('admin/trainings/templates') private templates!: any;

    private dialog: boolean = false;
    private loading: boolean = false;

    private async send(template) {
      this.loading = true;
      await this.sendMail({trainingId: this.training.id, templateId: template.id, ceos: this.ceos});
      this.loading = false;
      this.dialog = false;
    }
  }
